import { TaxIdFormat } from '../domains/tenant.domain';
import { TaxIdBase } from './tax-id-base';
import { BrazilTaxIdHelper } from './brazil-tax-id';
import { MexicoTaxIdHelper } from './mexico-tax-id';
import { ColombiaTaxIdHelper } from './colombia-tax-id';

export const getTaxIdHelper = (taxIdFormat: TaxIdFormat | undefined): TaxIdBase | undefined => {
  switch (taxIdFormat) {
    case TaxIdFormat.Brazil:
      return BrazilTaxIdHelper;
    case TaxIdFormat.Mexico:
      return MexicoTaxIdHelper;
    case TaxIdFormat.Colombia:
      return ColombiaTaxIdHelper;
    default:
      return undefined;
  }
};
